import {Injectable} from '@angular/core';
import {Document} from '../models/document';
import {User} from '../models/user';
import {MonitoringType} from '../models/monitoring-type';
import {DocumentType} from '../models/document-type';
import {AccountType} from '../models/account-type';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  private _identityDocuments: Document[] = [
    {
      id: 'Passport',
      value: DocumentType.Passport,
      requiredFront: true,
      requiredBack: false,
      requiredAdditional: false,
      requiredDate: true
    },
    {
      id: 'Id',
      value: DocumentType.Id,
      requiredFront: true,
      requiredBack: true,
      requiredAdditional: false,
      requiredDate: false
    },
    {
      id: 'DrivingLicense',
      value: DocumentType.DrivingLicense,
      requiredFront: true,
      requiredBack: false,
      requiredAdditional: false,
      requiredDate: true
    },
  ];

  private _addressDocuments: Document[] = [
    {
      id: 'DrivingLicense',
      value: DocumentType.DrivingLicense,
      requiredFront: true,
      requiredBack: false,
      requiredAdditional: true,
      requiredDate: false
    },
    {
      id: 'Government',
      value: DocumentType.Government,
      requiredFront: true,
      requiredBack: false,
      requiredAdditional: true,
      requiredDate: false
    },
    {
      id: 'UtilityBill',
      value: DocumentType.UtilityBill,
      requiredFront: true,
      requiredBack: false,
      requiredAdditional: true,
      requiredDate: false
    },
    {
      id: 'NationalInsurance',
      value: DocumentType.NationalInsurance,
      requiredFront: true,
      requiredBack: false,
      requiredAdditional: true,
      requiredDate: false
    },
  ];

  getIdentityDocuments(user: User) {
    if (user.monitoring === MonitoringType.USA) {
      return this._identityDocuments;
    }

    return this._identityDocuments.filter(x => x.id !== 'DrivingLicense');
  }

  getAddressDocuments(user: User) {
    // if (user.monitoring === MonitoringType.USA) {
    //   return [...this._addressDocuments].map(x => {
    //     x.requiredAdditional = true;
    //     return x;
    //   });
    // }
    return this._addressDocuments;
  }

  isValidDocuments(userModel: User) {
    if (userModel.documentsNotRequired) {
      return true;
    }

    return userModel.accountType === AccountType.Single
      ? this.ValidateForSingle(userModel)
      : this.validateForJoint(userModel);
  }

  private ValidateForSingle(userModel: User) {
    let isValidIdentityDocuments = false;
    if (userModel.proofIdentetyDocument) {
      const identityDocuments = this.getIdentityDocuments(userModel);
      const selectedIdentityDocument = identityDocuments.find(d => d.value === userModel.proofIdentetyDocument.type);

      isValidIdentityDocuments =
        (!selectedIdentityDocument.requiredFront || !!userModel.proofIdentetyDocument) &&
        (!selectedIdentityDocument.requiredBack || !!userModel.proofIdentetyBackDocument);
    }

    let isValidAddressDocuments = false;
    if (userModel.proofAddressDocument) {
      const addressDocuments = this.getAddressDocuments(userModel);
      const selectedAddressDocument = addressDocuments.find(d => d.value === userModel.proofAddressDocument.type);

      isValidAddressDocuments =
        (!selectedAddressDocument.requiredFront || !!userModel.proofAddressDocument) &&
        (!selectedAddressDocument.requiredBack || !!userModel.proofAddressBackDocument);
    }

    return isValidIdentityDocuments && isValidAddressDocuments;
  }

  private validateForJoint(userModel: User) {
    return this.ValidateForSingle(userModel) && this.ValidateForSecond(userModel);
  }

  private ValidateForSecond(userModel: User) {
    let isValidIdentityDocuments = false;
    if (userModel.secondHolder.proofIdentetyDocument) {
      const identityDocuments = this.getIdentityDocuments(userModel);
      const selectedIdentityDocument = identityDocuments.find(d => d.value === userModel.secondHolder.proofIdentetyDocument.type);
      isValidIdentityDocuments = (!selectedIdentityDocument.requiredFront || !!userModel.proofIdentetyDocument) &&
        (!selectedIdentityDocument.requiredBack || !!userModel.secondHolder.proofIdentetyBackDocument);
    }

    let isValidAddressDocuments = false;
    if (userModel.secondHolder.proofAddressDocument) {
      const addressDocuments = this.getAddressDocuments(userModel);
      const selectedAddressDocument = addressDocuments.find(d => d.value === userModel.secondHolder.proofAddressDocument.type);
      isValidAddressDocuments = (!selectedAddressDocument.requiredFront || !!userModel.secondHolder.proofAddressDocument) &&
        (!selectedAddressDocument.requiredBack || !!userModel.secondHolder.proofAddressBackDocument);
    }

    return isValidIdentityDocuments && isValidAddressDocuments;
  }
}
